import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { QueryUtils } from '@shared/util/query.utils';

@Injectable({ providedIn: 'root' })
export class RouteNavigationService {
  private static readonly ADMINTOOL_URL: string = 'admintool';
  private static readonly CONFIGURATOR_URL: string = 'configurator';

  constructor(private router: Router) {}

  public toLogin(keepQueryParams = true): Promise<boolean> {
    return this.router.navigate([`profile`, `login`], {
      queryParams: keepQueryParams ? QueryUtils.getAllParameters() : null,
    });
  }

  public toConfigurator(keepQueryParams = true): Promise<boolean> {
    (<any>window).toConfigurator = true;
    return this.router.navigate([RouteNavigationService.CONFIGURATOR_URL], {
      queryParams: keepQueryParams ? QueryUtils.getAllParameters() : null,
    });
  }

  public toAdmintool(keepQueryParams = true): Promise<boolean> {
    return this.router.navigate([RouteNavigationService.ADMINTOOL_URL], {
      queryParams: keepQueryParams ? QueryUtils.getAllParameters() : null,
    });
  }

  public isAtConfigurator(): boolean {
    const regExp = new RegExp(`${RouteNavigationService.CONFIGURATOR_URL}(?!\/)`);
    return regExp.test(this.router.url);
  }

  public toOpenProject(keepQueryParams = true): Promise<boolean> {
    return this.router.navigate([RouteNavigationService.CONFIGURATOR_URL, 'open-project'], {
      queryParams: keepQueryParams ? QueryUtils.getAllParameters() : null,
    });
  }
}
